import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/10 pt-20 pb-10 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/c790a797-f8bb-43f8-b6f5-1dd422b46a5f/4d06303e-0ea8-4bc5-b1b5-f007f7ddefea.jpg" 
          alt="Footer background" 
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80 z-10" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex flex-col items-start leading-none">
              <span className="text-3xl font-bold text-[#C1121F] tracking-tighter">L1</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-white font-medium">El-installatør</span>
            </Link>
            <p className="text-[#f1f1f1] text-sm leading-relaxed max-w-xs">
              L1 leverer moderne, sikre og effektive el-installationer med fokus på kvalitet, driftssikkerhed og professionelt håndværk.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-white hover:text-[#C1121F] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-white hover:text-[#C1121F] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-white hover:text-[#C1121F] transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Vi tilbyder</h4>
            <ul className="space-y-4">
              <li><Link to="/vi-tilbyder/el-installatoer" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">El-installatør</Link></li>
              <li><Link to="/vi-tilbyder/kabler" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Kabler</Link></li>
              <li><Link to="/vi-tilbyder/elektriker" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Elektriker</Link></li>
              <li><Link to="/vi-tilbyder/fagentrepriser" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Fagentrepriser</Link></li>
              <li><Link to="/vi-tilbyder/installationer" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Installationer</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Hurtige links</h4>
            <ul className="space-y-4">
              <li><Link to="/" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Forside</Link></li>
              <li><Link to="/om-os" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Om os</Link></li>
              <li><Link to="/kontakt" className="text-[#f1f1f1] hover:text-white transition-colors text-sm uppercase tracking-wide font-medium">Kontakt os</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-white shrink-0" />
                <a href="tel:+4522518070" className="text-[#f1f1f1] hover:text-white transition-colors text-sm">22 51 80 70</a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-white shrink-0" />
                <a href="mailto:L12026@outlook.dk" className="text-[#f1f1f1] hover:text-white transition-colors text-sm">L12026@outlook.dk</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-white shrink-0" />
                <span className="text-[#f1f1f1] text-sm">Danmark</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#f1f1f1]/60 text-xs">
            © {new Date().getFullYear()} L1 El-installatør. Alle rettigheder forbeholdes.
          </p>
          <p className="text-[#f1f1f1]/60 text-xs uppercase tracking-widest">
            CVR: 46200373
          </p>
        </div>
      </div>
    </footer>
  );
}
